"use client";

import { usePathname } from "next/navigation";
import { MessageCircle } from "lucide-react";

const IKAI_WHATSAPP_URL = encodeURI(
  "https://wa.me/19129224004?text=Merhaba, IKAI hakkında bilgi almak istiyorum. Demo, fiyatlandırma ve şirketimize uygun kullanım senaryosu için yardımcı olur musunuz?"
);

export default function PublicAssistantShell() {
  const pathname = usePathname();

  if (pathname === "/blog" || pathname?.startsWith("/blog/")) {
    return null;
  }

  return (
    <a
      href={IKAI_WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-2xl transition-all duration-300 hover:scale-110 hover:bg-green-600 hover:shadow-green-500/40"
      aria-label="IKAI WhatsApp sohbeti başlat"
      title="IKAI WhatsApp sohbeti başlat"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="absolute -right-1 -top-1 flex h-4 w-4">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-300 opacity-75" />
        <span className="relative inline-flex h-4 w-4 rounded-full border-2 border-white bg-green-400" />
      </span>
    </a>
  );
}
